/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForAutoAssessment extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForAutoAssessment");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForAutoAssessment.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForAutoAssessment>): BackgroundJobPayloadForAutoAssessment {
        let obj = Object.assign(new BackgroundJobPayloadForAutoAssessment(), model);
        BackgroundJobPayloadForAutoAssessment.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForAutoAssessment>): BackgroundJobPayloadForAutoAssessment {
        if (!model) return null;
        return BackgroundJobPayloadForAutoAssessment.newInstance(<BackgroundJobPayloadForAutoAssessment> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForAutoAssessment) {
        if (!obj) return;

        models.BackgroundJobPayloadForAutoAssessment.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForAutoAssessment): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForAutoAssessment.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * State of the Auto Assessment background job
     */
    state: models.BackgroundJobPayloadForAutoAssessmentState;

    /**
     * Cloud account ID of the Auto Assessment
     */
    cloud_account_id: string;

    /**
     * Assessment run ID of the Auto Assessment
     */
    assessment_run_id: string;

    /**
     * ID of the report being generated for Auto Assessment
     */
    report_id: string;

}
